import type React from "react";
import { ReactComponent as Svg } from "./icon-picklebet.svg";

type PicklebetIconProps = React.SVGProps<SVGSVGElement>;

export const PicklebetIcon = (props: PicklebetIconProps) => <Svg {...props} />;
